
import { Component, Vue, Prop, namespace } from 'nuxt-property-decorator';
import { EventDto } from 'fourwaves-shared';

const EventsModule = namespace('events');

@Component
export default class Header extends Vue {
  @Prop({ type: String, default: null }) readonly title!: string | null;
  @Prop({ type: String, default: null }) readonly description!: string | null;
  @Prop({ type: Boolean, default: false }) readonly formPage!: boolean;
  @Prop({ type: Boolean, default: false }) readonly schedulePage!: boolean;

  @EventsModule.Getter currentEvent!: EventDto;

  get rootClassNames(): Record<string, boolean> {
    return {
      '-form-page': this.formPage,
      '-schedule-page': this.schedulePage,
    };
  }
}
